import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

type HighlightAddOn = {
  name: string
  src: string
}

const isNotIn = (highlights: HighlightAddOn[]) => (addOnName: string) =>
  !highlights.some(({ name: highlightName }) => highlightName === addOnName)

const removeNulls = (possibleHighlights: Maybe<HighlightAddOn>[]) =>
  possibleHighlights.filter(isTruthy)

export const useLineItem = (
  licensedTerritory: MaybeRefOrGetter<string>,
  lotteryId: MaybeRefOrGetter<LotteryId>,
  highlightAddOn: MaybeRefOrGetter<boolean>,
  addOns: Ref<string[]>,
) => {
  const { getLotteryHighlight } = useAsset()

  const getHighlights = async () => {
    if (!toValue(highlightAddOn)) return Promise.resolve([])
    const possibleHighlights = addOns.value.map(toHighlightAddOn)
    return await Promise.all(possibleHighlights).then(removeNulls)
  }

  const getLowlights = (highlights: HighlightAddOn[]) => addOns.value.filter(isNotIn(highlights))

  const splitAddOns = async () => {
    const highlightAddOns = await getHighlights()
    const lowlightAddOns = getLowlights(highlightAddOns)

    return Promise.resolve({ highlightAddOns, lowlightAddOns })
  }

  const toHighlightAddOn = async (name: string): Promise<Maybe<HighlightAddOn>> => {
    const src = await getLotteryHighlight(name)
    return src ? { name, src } : null
  }

  return useAsyncData(`${toValue(licensedTerritory)}_${toValue(lotteryId)}_addons`, splitAddOns, {
    watch: [() => licensedTerritory, () => lotteryId, () => highlightAddOn],
  })
}
